import { TableCell, TableRow, Tooltip } from "@mui/material";
import { Icons, Images } from "assets";
import styles from "pages/phNewPendingTasks/style.module.scss";
import { user_roles } from "shared/utils/constants";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const PendingTransaction = () => {
  const tasksList = [
    {
      role: 3,
      status: 1,
    },
    {
      role: 4,
      status: 2,
    },
    {
      role: 3,
      status: 3,
    },
    {
      role: 4,
      status: 4,
    },
    {
      role: 4,
      status: 4,
    },
    {
      role: 4,
      status: 4,
    },
  ];

  return (
    <>
      {tasksList?.map((item: any, index: any, arr: any) => {
        return (
          <TableRow
          // className={classNames(index + 1 === arr.length && styles.lastCells)}
          >
            <TableCell>
              <div className={styles.nameCell}>
                <img
                  src={Images.UserPlaceholderImage}
                  alt="profile_picture"
                  className={styles.profilepic}
                />
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label>Jane Doe</label>
                  <label className={styles.emailLabel}>janedoe@gmail.com</label>
                </div>
              </div>
            </TableCell>
            <TableCell>
              {item?.role === user_roles.reader
                ? "Reader"
                : item?.role === user_roles.parent
                ? "Parent"
                : ""}
            </TableCell>
            <TableCell>2000</TableCell>
            <TableCell>Soft Copy</TableCell>
            <TableCell>
              <div className={styles.actionContainer}>
                <Tooltip arrow title={"Upload Receipt"}>
                  <div>
                    <CloudUploadIcon sx={{ color: "#868E96" }} />
                  </div>
                </Tooltip>
              </div>
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
};

export default PendingTransaction;
